import { render, staticRenderFns } from "./ShareBlock.vue?vue&type=template&id=367650da&scoped=true&"
import script from "./ShareBlock.vue?vue&type=script&lang=js&"
export * from "./ShareBlock.vue?vue&type=script&lang=js&"
import style0 from "./ShareBlock.vue?vue&type=style&index=0&id=367650da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367650da",
  null
  
)

export default component.exports